import { CKBox } from '@clearkit/react';
import { Link } from 'react-router-dom';

import { StageListItem } from '~/components/audiences/StageListItem';
import { stages } from '~/lib/salesPipeline';

const Placeholder = () => {
  return (
    <CKBox className="flex flex-col justify-center flex-1 p-2 text-center shadow-none cursor-default bg-gray-0">
      <p className="text-xs leading-tight text-gray-600">
        Define Leads and MQL metrics for a more complete story
      </p>
      <Link
        className="text-xs font-medium ck-link"
        to="/audiences/configure-roi-metrics">
        Configure
      </Link>
    </CKBox>
  );
};

export const StageList = ({ data, toggleStage, activeStageKeys }) => {
  if (!data) {
    return (
      <p className="text-sm text-gray-600">
        No stage data available at this time.
      </p>
    );
  }

  const renderStage = (stage) => (
    <StageListItem
      data={data[stage.key]}
      {...stage}
      onClick={() => toggleStage(stage.key)}
      active={activeStageKeys.includes(stage.key)}
    />
  );

  const disabledStages = stages.filter((stage) => {
    const stageData = data[stage.key];

    return stageData.enabled === false;
  });

  // Show placeholder if neither of the optional stages have been enabled
  const shouldShowPlaceholder = disabledStages.length === 2;

  return (
    <div className="flex justify-between space-x-2">
      {renderStage(stages[0])}
      {shouldShowPlaceholder === true && <Placeholder />}
      {shouldShowPlaceholder === false && (
        <>
          {renderStage(stages[1])}
          {renderStage(stages[2])}
        </>
      )}
      {renderStage(stages[3])}
      {renderStage(stages[4])}
    </div>
  );
};
